import {
  CircularProgress,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { forwardRef } from "react";
import { useGetList } from "react-admin";
import resourceNames from "../../../../common/data/resourceNames";
import { useTableHeaderStyles } from "../common";
import { Empty } from "../widgets/Empty";
import { Widget } from "../widgets/Widget";
import { VehicleWidgetProps } from "./VehicleWidgetProps";
import "./VehicleMaintenanceWidget.css";
import { Warning } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) => ({
  warning: {
    color: theme.palette.warning.main,
  },
}));

export const VehicleMaintenanceWidget = forwardRef(
  ({ className, icon, title, vehicle, ...rest }: VehicleWidgetProps, ref) => {
    const classes = useTableHeaderStyles();
    const componentClasses = useStyles();
    const { data, ids, loading } = useGetList(
      resourceNames.ASSETS_VEHICLE_MAINTENANCE,
      undefined,
      { field: "date", order: "DESC" },
      { vehicleId: vehicle.id, nextMaintenanceDone: false }
    );

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}
      >
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && ids && ids.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell>Last oil change date</TableCell>
                      <TableCell>Last oil change miles</TableCell>
                      <TableCell>Notes</TableCell>
                      <TableCell>Next oil change date</TableCell>
                      <TableCell>Next oil change miles</TableCell>
                      <TableCell>Next oil change notes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ids.map((id) => (
                      <TableRow key={id}>
                        <TableCell>
                          {format(parseISO(data[id].date!), "MMM do, yyyy")}
                        </TableCell>
                        <TableCell>{data[id].vehicleOdometer}</TableCell>
                        <TableCell>{data[id].notes}</TableCell>
                        <TableCell>
                          {data[id].nextMaintenanceDate ? (
                            <div className="due-maintenance-info-cell">
                              <Typography variant="body2">
                                {format(
                                  parseISO(data[id].nextMaintenanceDate),
                                  "MMM do, yyyy"
                                )}
                              </Typography>
                              {parseISO(data[id].nextMaintenanceDate) <=
                              new Date() ? (
                                <div
                                  className={`info-value-icon ${componentClasses.warning}`}
                                >
                                  <Warning />
                                </div>
                              ) : null}
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {data[id].nextMaintenanceOdometer ? (
                            <div className="due-maintenance-info-cell">
                              <Typography variant="body2">
                                {data[id].nextMaintenanceOdometer}
                              </Typography>
                              {data[id].nextMaintenanceOdometer <=
                              (vehicle.mileage ?? 0) ? (
                                <div
                                  className={`info-value-icon ${componentClasses.warning}`}
                                >
                                  <Warning />
                                </div>
                              ) : null}
                            </div>
                          ) : (
                            "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {data[id].nextMaintenanceNotes ?? "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <Empty />
          )}
        </div>
      </Widget>
    );
  }
);
